document.addEventListener("DOMContentLoaded", function () {
  const resetBtn = document.getElementById("reset-filters");

  if (resetBtn) {
    resetBtn.addEventListener("click", function () {
      const url = window.location.pathname;

      fetch(url)
        .then(response => response.text())
        .then(html => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');

          const newGrid = doc.querySelector('[data-id="main-collection-product-grid"]');
          const currentGrid = document.querySelector('[data-id="main-collection-product-grid"]');

          if (newGrid && currentGrid) {
            currentGrid.innerHTML = newGrid.innerHTML;
          }

          // Reset the filters form too
          const filtersForm = document.querySelector('facet-filters-form form');
          if (filtersForm) {
            filtersForm.reset();
          }

          history.pushState({}, '', url);
        });
    });
  }
});
